module.exports = __webpack_public_path__ + "img/eugene-baleni.01083593.png";